import React from '../services/React';
import UI from '../services/UI';

function withBackButton(WrappedComponent) {
  return function(props) {
    return (
      <div>
        <UI.button
          label="Back"
          className="btn-back"
          onClick={props.gotoPrevComponent}
        />
        <WrappedComponent {...props} />
      </div>
    );
  };
}

export default withBackButton;



// WEBPACK FOOTER //
// ./src/commons/components/withBackButton.jsx